import "./index.scss";

import { Box, Stack } from "@mui/material";
import Button from "components/Button";
import ScreenLoader from "components/ScreenLoader";
import { Protocol } from "models/protocol";
import { getProtocolById } from "modules/protocol/protocolServices";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import ProtocolCreateEditModal from "../ProtocolCreateEditModal";

function ProtocolView() {
  const [loading, setLoading] = useState(false);
  const [protocol, setProtocol] = useState<Protocol>();
  const [showEditModal, setShowEditModal] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    setLoading(true);
    getProtocolById({ id })
      .then((r) => {
        if (r.success) {
          setProtocol(r.data);
        }
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handleCloseModal = (isRefreshNeeded = false) => {
    setShowEditModal(false);
    if (typeof isRefreshNeeded == "boolean" && isRefreshNeeded) {
      setLoading(true);
      window.location.reload();
    }
  };

  if (loading) {
    return <ScreenLoader isScreenLoader={true} />;
  }

  return (
    <>
      <Box className="manage-protocol-container" p={5}>
        <Stack direction="row" justifyContent="space-between" gap={2} alignItems="center">
          <p className="circuit-title">{protocol?.title}</p>
          {!protocol?.is_fitlinxx_standard && (
            <Button className="edit-button" label="Edit" onClick={() => setShowEditModal(true)} />
          )}
        </Stack>
        <Box marginTop={4} className="details-container">
          <Stack direction="row" className="description">
            <label>Protocol Description</label>
            <p>{protocol?.description}</p>
          </Stack>
          <Box className="details-box">
            <p className="title">Times</p>
            <Stack direction="row" gap={"10px"}>
              <Stack className="times-item">
                <label>Min Lift Time</label>
                <p>{protocol?.min_lift_time_for_display}</p>
              </Stack>
              <Stack className="times-item">
                <label>Min Drop Time</label>
                <p>{protocol?.min_drop_time_for_display}</p>
              </Stack>
              <Stack className="times-item">
                <label>Rest Time</label>
                <p>{protocol?.rest_time}</p>
              </Stack>
            </Stack>
          </Box>

          <Box mt={"10px"} className="details-box">
            <p className="title">Sets</p>
            <Box className="set-items-container">
              {protocol?.sets?.map((e, index) => (
                <Box className="set-item" key={`set${index}`}>
                  <p className="title">Set {index + 1}</p>
                  <Stack className="info">
                    <Stack className="info-header">
                      <p>Min Reps</p>
                      <p>Max Reps</p>
                    </Stack>
                    <Stack className="info-row">
                      <p>{e.min_reps}</p>
                      <p>{e.max_reps}</p>
                    </Stack>
                  </Stack>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
      <ProtocolCreateEditModal
        open={showEditModal}
        onClose={handleCloseModal}
        entryId={parseInt(id)}
      />
    </>
  );
}

export default ProtocolView;
